export default __webpack_public_path__ + "static/media/communityMap.9375b130.svg";